import { lastValueFrom } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { PORTAL_API_BASE_URL } from '@echospaces-web-monorepo/es-portal-shell';

import type { AuthUser, EsRolesLoader } from '@echospaces-web-monorepo/es-auth';

/**
 * Resolves the signed-in user's org-scoped roles for the portal.
 *
 * Org roles (super-admin / editors / staff) live in Phase Two and never
 * appear in the Keycloak access token, so the AuthService can't read them
 * from the JWT. Provided under `ES_ROLES_LOADER`, this fetches them from the
 * BFF after login; AuthService merges the result into `user.roles` so the
 * sidebar, route guards, and admin panels gate correctly.
 */
@Injectable({ providedIn: 'root' })
export class PortalRolesLoader implements EsRolesLoader {
  private readonly http = inject(HttpClient);
  private readonly api = inject(PORTAL_API_BASE_URL);

  async loadRoles(user: AuthUser): Promise<string[]> {
    const orgId = user.organizationId;
    if (!orgId) return [];
    const res = await lastValueFrom(
      this.http.get<{ roles: string[] }>(`${this.api}/companies/${orgId}/members/me`),
    );
    return res.roles ?? [];
  }
}
